import React, { useState } from "react";
import { useGlobalContext } from "../../GlobalContext";
import MutasiSimpUSP from "./pdf/mutasiusp"; 

function MutasiSimpUSPComponent() {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);

  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [jenisTransaksi, setJenisTransaksi] = useState("simpananpokok");
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleBulanChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 0 && value < bulan.length) {
      setSelectedBulan(value);
    } else {
      console.error("Bulan tidak valid:", value);
    }
  };

  const handleTahunChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleChange = (e) => {
    setJenisTransaksi(e.target.value);
  };

  const handleSubmit = async () => {
    let bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    let periode = `${selectedYear}${bulanNumber}`;
    let namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    let tahun = selectedYear;

    setLoading(true);

    try {
      const response = await api.get(`/api/laporan/mutasisaham/${periode}/${jenisTransaksi}`);
      const result = response.data.data;  
      
      if (!Array.isArray(result) || result.length === 0) {
        alert(`Datas tidak ditemukan untuk periode ${namaBulan} ${tahun}.`);
      } else {
        MutasiSimpUSP(periode, result, namaBulan, tahun, jenisTransaksi);
      }
    } catch (error) {
      console.error("Gagal mengambil data:", error);
      alert(`Terjadi kesalahan saat mengambil data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    let bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    let periode = `${selectedYear}${bulanNumber}`;
    let namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    let tahun = selectedYear;

    setIsExporting(true);

    try {      
      const response = await api.get(`/api/exsportexcell/mutasisaham/${periode}/${jenisTransaksi}`, {
        responseType: "blob",        
      });

      const filename = `Laporan_Mutasi_USP_${namaBulan}_${tahun}.xlsx`;
      const blob = new Blob([response.data], { 
        type: response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export Excel error:", error);
      alert("Gagal mengekspor Excel.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-info" style={{ width: "400px" }}>
              <div className="card-header">
                <h5 className="card-title">Laporan Mutasi Simpanan USP</h5>
              </div>
              <div className="card-body">
                <form className="form-horizontal">
                  <div className="form-group row mb-2">
                    <label htmlFor="bulan" className="col-sm-3 col-form-label">Periode</label>
                    <div className="col-sm-6" style={{ flex: 1 }}>
                      <select className="form-control" name="bulan" value={selectedBulan} onChange={handleBulanChange}>
                        {bulan.map((item, index) => (
                          <option key={index} value={index}>{item}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-4" style={{ flex: 1 }}>
                      <select className="form-control" name="tahun" value={selectedYear} onChange={handleTahunChange}>
                        {tahunterakhir.map((year) => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group row mb-1">
                    <label htmlFor="jenisTransaksi" className="col-sm-3 col-form-label">Jenis</label>
                    <div className="com-md-8 col-sm-8">
                      <select className="form-control" name="jenisTransaksi" value={jenisTransaksi} onChange={handleChange}>
                        <option value="simpananpokok">Simpanan Pokok</option>
                        <option value="simpananwajib">Simpanan Wajib</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit} disabled={loading || isExporting}>
                  {loading ? "Mengambil Data..." : "Cetak"}
                </button>
                <button type="button" className="btn btn-sm btn-success" onClick={handleExportExcel} disabled={loading || isExporting} style={{ marginLeft: 8 }}>
                  {isExporting ? "Mengekspor..." : "Export Excel"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MutasiSimpUSPComponent;
